import { render, staticRenderFns } from "./Confirmar.vue?vue&type=template&id=08fba171&"
import script from "./Confirmar.vue?vue&type=script&lang=js&"
export * from "./Confirmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports